import { useContext } from 'react';

import { type IToastContextData, ToastContext } from '../contexts/toast';

export const useToast = (): IToastContextData => useContext(ToastContext);
